export enum Rings {
	HOLD = "Hold",
	ASSESS = "Assess",
	TRIAL = "Trial",
	ADOPT = "Adopt",
}